/* TP Produktkarte — Zustands-Popover.
   Das Panel wird als position:fixed über (bzw. bei Platzmangel unter) dem Trigger platziert
   und am Viewport geclampt. Dadurch entkommt es dem Carousel-Scrollcontainer (overflow-x:auto)
   und wird weder horizontal noch vertikal abgeschnitten.
   Steuerung: Hover + Fokus (Desktop) und Tap-Toggle (Touch). Idempotent. */
(function () {
  if (window.__tpCondPopBound) return;
  window.__tpCondPopBound = true;

  var current = null;
  var closeTimer = null;
  var GAP = 9;
  var M = 8; // Viewport-Sicherheitsabstand

  function panelOf(trig) {
    return trig.querySelector('.tp-cpop__panel');
  }

  function place(trig) {
    var panel = panelOf(trig);
    if (!panel) return;
    // Erst alle Reads, dann alle Writes: Schreiben vor getBoundingClientRect
    // erzwang pro Aufruf ein synchrones Layout (IT#16835). Breite/Hoehe des
    // Panels sind per CSS fix, daher unabhaengig von absolute/fixed.
    var tr = trig.getBoundingClientRect();
    var pw = panel.offsetWidth;
    var ph = panel.offsetHeight;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    // horizontal: rechtsbündig zum Trigger, dann in den Viewport clampen
    var left = Math.max(M, Math.min(tr.right - pw, vw - pw - M));
    // vertikal: bevorzugt über dem Trigger; sonst darunter
    var top = tr.top - ph - GAP;
    if (top < M) top = Math.min(tr.bottom + GAP, vh - ph - M);
    panel.style.position = 'fixed';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
    panel.style.margin = '0';
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
  }

  function reset(trig) {
    var panel = panelOf(trig);
    if (!panel) return;
    panel.style.position = '';
    panel.style.left = '';
    panel.style.top = '';
    panel.style.right = '';
    panel.style.bottom = '';
    panel.style.margin = '';
  }

  // Top-Layer (Popover-API): Safari schneidet ein position:fixed-Panel trotzdem an der
  // gerundeten overflow:hidden-Karte ab; im Top-Layer clippt kein Vorfahr mehr.
  // DOM-Position bleibt, damit erben CSS-Variablen und trig.contains() weiter.
  function show(panel, on) {
    if (!panel || !panel.showPopover) return;
    if (!panel.popover) panel.popover = 'manual';
    if (panel.matches(':popover-open') !== on) on ? panel.showPopover() : panel.hidePopover();
  }

  function open(trig) {
    clearTimeout(closeTimer);
    if (current && current !== trig) close(current);
    current = trig;
    show(panelOf(trig), true); // vor place(): geschlossenes Popover ist display:none
    place(trig);
    trig.classList.add('is-open');
  }

  function close(trig) {
    trig.classList.remove('is-open');
    reset(trig);
    show(panelOf(trig), false);
    if (current === trig) current = null;
  }

  function scheduleClose(trig) {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { close(trig); }, 140);
  }

  // Hover (Maus) — pointerover/out bubblen, sodass Trigger↔Panel als Einheit zählen
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var trig = e.target.closest && e.target.closest('.tp-cpop');
    if (trig) open(trig);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'touch') return;
    var trig = e.target.closest && e.target.closest('.tp-cpop');
    if (!trig) return;
    var to = e.relatedTarget;
    if (to && trig.contains(to)) return; // noch innerhalb von Trigger oder Panel
    scheduleClose(trig);
  });

  // Tastatur-Fokus
  document.addEventListener('focusin', function (e) {
    var trig = e.target.closest && e.target.closest('.tp-cpop');
    if (trig) open(trig);
  });
  document.addEventListener('focusout', function (e) {
    var trig = e.target.closest && e.target.closest('.tp-cpop');
    if (trig) scheduleClose(trig);
  });

  // Tap/Klick — Toggle, ohne über den Karten-Overlay-Link zu navigieren
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('.tp-cpop');
    if (trig) {
      var link = e.target.closest('a');
      if (link && trig.contains(link)) return; // echter Link im Panel durchlassen
      if (e.target.closest('.tp-cpop__panel')) return; // Klick im Panel-Body: offen lassen
      e.preventDefault();
      e.stopPropagation();
      if (trig.classList.contains('is-open')) close(trig); else open(trig);
      return;
    }
    if (current) close(current);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) close(current);
  });

  // Position bei Scroll/Resize aktuell halten — passiv und auf einen Aufruf pro Frame
  // gebuendelt (vorher: `true` = capture statt passive, place() bei jedem Scroll-Event).
  var raf = 0;
  function reposition() {
    if (raf || !current) return;
    raf = requestAnimationFrame(function () { raf = 0; if (current) place(current); });
  }
  window.addEventListener('scroll', reposition, { passive: true, capture: true });
  window.addEventListener('resize', reposition);
})();
